module.exports = __webpack_public_path__ + "img/Klizer_Logo_JustLogo.e42387cf.png";